module.exports = {
  footerText: 'Copyright Eureka Logistic © 2023',
}
